import React from 'react';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import styles from './Button.module.scss';
import { H4 } from './Typography';
import { ClickableBox } from './Boxes';

function Button(props) {
  const fluidStyle = props.fluid ? styles.fluidButton : '';
  return (
    <div>
      <button
        type="button"
        className={cn(props.className, styles.button, fluidStyle)}
        onClick={props.onClick}>
        {props.text}
      </button>
    </div>
  );
}

export const PrimaryButton = (props) => (
  <Button {...props} className={cn(styles.primaryButton, props.className)} />
);

export const SmallPrimaryButton = (props) => (
  <Button {...props} className={cn(styles.smallPrimaryButton, styles.primaryButton, props.className)} />
);
export const SubmitButton = (props) => (
  <input
    type="submit"
    {...props}
    className={cn(styles.primaryButton, styles.submitButton, props.className)}
  />
);

export const FluidPrimaryButton = (props) => (
  <Button fluid className={styles.primaryButton} {...props} />
);

export const InvertedFluidPrimaryButton = (props) => (
  <Button fluid className={styles.invertedPrimaryButton} {...props} />
);

export default Button;

export const RouteButton = withRouter((props) => (
  <TextOnlyUnderlinedButton
    text={props.text}
    onClick={() => props.history.push(props.routeTo)}
  />
));

export const GoBackRouteButton = withRouter((props) => (
  <TextOnlyUnderlinedButton
    text={props.text}
    onClick={() => props.history.goBack()}
    className={props.marketing === 'true' ? styles.marketingGoBack : ''}
  />
));

export const TextOnlyUnderlinedButton = ({
  onClick, text, style, className,
}) => (
  <ClickableBox onClick={onClick}>
    <H4 className={`${styles.textOnlyUnderlinedButton} ${className || ''}`} style={style}>
      {text}
    </H4>
  </ClickableBox>
);

export const WhiteSquareButton = ({ onClick, text }) => (
  <WhiteSquareButtonContent onClick={onClick}>
    <H4>{text}</H4>
  </WhiteSquareButtonContent>
);

export const WhiteSquareButtonContent = ({ onClick, children }) => (
  <ClickableBox className={styles.whiteSquareButton} onClick={onClick}>
    {children}
  </ClickableBox>
);
